/*
 * Used to create activity log URLs for Facebook.
 * Each value is a possible value for the url parameter "category_key".
 */
export enum FacebookContentCategoryKey {
  COMMENTS_REACTIONS = 'YOURACTIVITYCOMMENTSANDREACTIONSSCHEMA',

  COMMENTS_ONLY = 'COMMENTSCLUSTER',
  REACTIONS_ONLY = 'LIKEDPOSTS',

  POSTS = 'YOURACTIVITYPOSTSSCHEMA',
  POSTS_PHOTOS_VIDEOS = 'MANAGEPOSTSPHOTOSANDVIDEOS',
  CHECKINS = 'CHECKINS',

  HIDDEN_POSTS = 'HIDDENSTORIES',
  OTHERS_POSTS_ON_YOUR_TIMELINE = 'WALLCLUSTER',
  VIDEOS_YOU_WATCHED = 'VIDEOWATCH',
  LIVE_VIDEOS_WATCHED = 'LIVEVIDEOWATCH',
  REVIEWS = 'RATINGSANDREVIEWS',
  ARTICLES_READ = 'OGBUILTINNEWS',

  PAGES = 'LIKEDINTERESTS',

  PERSONAL_INFO = 'PERSONALINFOPROFILEINFOSCHEMA',
}

export const aboutUrl = 'https://www.facebook.com/profile.php?sk=about'
export const aboutContactAndBasicInfoUrl =
  'https://www.facebook.com/profile.php?sk=directory_contact_info'
export const aboutWorkUrl =
  'https://www.facebook.com/profile.php?sk=directory_work'
export const aboutEducationUrl =
  'https://www.facebook.com/profile.php?sk=directory_education'
export const aboutPersonalDetailsUrl =
  'https://www.facebook.com/profile.php?sk=directory_personal_details'
export const accountsCenterUrl =
  'https://accountscenter.facebook.com/?entry_point=app_settings'
export const albumsUrl = 'https://www.facebook.com/profile.php?sk=photos_albums'
export const disconnectAppsAndSettingsUrl =
  'https://www.facebook.com/settings?tab=applications&ref=settings'
export const homeUrl = 'https://www.facebook.com'
export const languageUrl = 'https://www.facebook.com/settings?tab=language'
export const nameUrl =
  'https://www.facebook.com/settings?tab=account&section=name&view'
export const privacyCenterUrl =
  'https://www.facebook.com/privacy/checkup/?source=settings_and_privacy'
export const profileAndTaggingSettingsUrl =
  'https://www.facebook.com/settings/?tab=profile_and_tagging'
export const profileSettingsUrl =
  'https://www.facebook.com/settings/?tab=profile'
export const profileUrl = 'https://www.facebook.com/profile.php'
export const taggedPhotosUrl =
  'https://www.facebook.com/profile.php?sk=photos_of'
export const twofaSettingsUrl =
  'https://www.facebook.com/security/2fac/settings/'
export const postsUrl = 'https://www.facebook.com/settings/?tab=posts' // New settings page
export const howPeopleFindYouUrl =
  'https://www.facebook.com/settings/?tab=how_people_find_and_contact_you' // New settings page
export const forcedAccountSwitchUrl =
  'https://www.facebook.com/forced_account_switch'
export const reauthBaseUrl = 'https://www.facebook.com/login/reauth.php'
export const securedActionBlockUrl =
  'https://www.facebook.com/secured_action/block/'
export const followersAndPublicContentUrl =
  'https://www.facebook.com/settings/?tab=followers_and_public_content'
export const notificationsUrl =
  'https://www.facebook.com/settings/?tab=notifications'
export const friendsListUrl = 'https://www.facebook.com/friends/list'
export const accountCenterTwoFactorAuthUrl =
  'https://accountscenter.facebook.com/password_and_security/two_factor'
export const messengerUrl = 'https://www.facebook.com/messages/'

export function getAccountsCenterUrl(userId: string): string {
  return `https://accountscenter.facebook.com/profiles/${userId}/`
}
export function getAccountsCenterEditUsernameUrl(userId: string): string {
  return `https://accountscenter.facebook.com/profiles/${userId}/username`
}

export function getActivityLogUrl(
  userId: string,
  categoryKey: FacebookContentCategoryKey,
  year?: number,
  month?: number,
): string {
  const allActivityUrl = `https://www.facebook.com/${userId}/allactivity?activity_history=false`

  const yearFilter = year ? `&year=${year}` : ''
  const monthFilter = year && month ? `&month=${month}` : ''

  return `${allActivityUrl}&category_key=${categoryKey}${yearFilter}${monthFilter}`
}

export function getTrashUrl(userId: string): string {
  const allActivityUrl = `https://www.facebook.com/${userId}/allactivity?activity_history=false`

  return `${allActivityUrl}&category_key=TRASH`
}
